export enum AppRoles {
  VENUE_MANAGER = 'venue_manager',
  VENUE_USER = 'venue_user',
  ORGANIZATION_MANAGER = 'organization_manager',
  ORGANIZATION_USER = 'organization_user'
}
